// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT: AXIS360 IQ Assessment
// ─────────────────────────────────────────────────────────────────────────────
import { IQ_QUESTIONS, IQ_SECTIONS, rawToIQ, sectionRawToIQ,
         iqToPercentile, getIQBand } from "../../constants/iqQuestions.js";

const IQ = {
  id:           "iq",
  name:         "AXIS360 IQ Assessment",
  shortName:    "IQ",
  icon:         "🧠",
  color:        "#7c3aed",
  bg:           "#f5f3ff",
  description:  "Comprehensive corporate cognitive ability assessment measuring verbal, numerical, abstract and logical reasoning. Produces a composite IQ score (70–140), percentile rank and hiring recommendation.",
  desc:         "Verbal · Numerical · Abstract · Logical · 40 min",
  publisher:    "AXIS360 Assess",
  version:      "1.0",
  itemCount:    60,
  items:        60,
  totalQuestions: 60,
  timeLimit:    40,
  time:         "40 min",
  timeEstimate: "40 minutes",
  format:       "multiple_choice",
  sections:     IQ_SECTIONS,
  nineboxAxes:  { x:"Numerical IQ", y:"Verbal IQ" },

  scoreResult(answers = {}) {
    const sectionScores = IQ_SECTIONS.map(sec => {
      const qs      = IQ_QUESTIONS.filter(q => q.section === sec.id);
      const correct = qs.filter(q => answers[q.id] === q.answer).length;
      return { sectionId: sec.id, correct, total: qs.length,
               iq: sectionRawToIQ(correct, qs.length) };
    });
    const totalCorrect = sectionScores.reduce((s,r) => s + r.correct, 0);
    const compositeIQ  = rawToIQ(totalCorrect, 60);
    const percentile   = iqToPercentile(compositeIQ);
    const band         = getIQBand(compositeIQ);
    const verbalIQ     = Math.round((sectionScores[0].iq + sectionScores[3].iq) / 2);
    const numericalIQ  = Math.round((sectionScores[1].iq + sectionScores[2].iq) / 2);
    return {
      compositeIQ, percentile, band, sectionScores,
      verbalIQ, numericalIQ, totalCorrect,
      scales:  { compositeIQ, verbalIQ, numericalIQ, percentile },
      perfAvg: compositeIQ,
      potAvg:  parseFloat((percentile / 10).toFixed(1)),
      perfBox: Math.min(3, Math.max(1, Math.round((compositeIQ - 70) / 23 + 1))),
      potBox:  Math.min(3, Math.max(1, Math.round(percentile / 34 + 1))),
    };
  },
};

export default IQ;
